export class GabinetePermission{
  access = 531;
  pr_tasks = 533;
  md_tasks = 532;
  aprove_event = 507;
}
